import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./sass/variable.scss";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueTouch from "vue-touch";
import * as VueGoogleMaps from "vue2-google-maps";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

Vue.use(VueTouch);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_API_KEY,
    libraries: "places",
  },
  installComponents: true,
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
